import React, { useState } from "react";
import { Outlet } from "react-router-dom";

import { CustomSidebar, CustomHeader } from "./components";

import "./style.scss";

function LayoutView() {
  const [layoutState, setLayoutState] = useState<string>(
    "layout__with_sidebar",
  );

  const [refetchHeaderState, setRefetchHeaderState] = useState<boolean>(false);

  const onRefetchHeaderState = () => {
    setRefetchHeaderState((prev) => !prev);
  };

  return (
    <div className={`container overflow-hidden ${layoutState}`}>
      <div className="sidebar">
        <CustomSidebar />
      </div>
      <div className="main">
        <CustomHeader
          layoutState={layoutState}
          setLayoutState={setLayoutState}
          refetchHeaderState={refetchHeaderState}
        />
        <Outlet context={{ refetchHeaderState, onRefetchHeaderState }} />
      </div>
    </div>
  );
}

export default LayoutView;
